import { P3Regular as P3RegularStyle } from 'theme/typography';
import { Text, TextProps } from '@mantine/core';
import mergeTextSx from 'components/typography/merge-text-sx';

/**
 * Applies the P3Regular typography style.
 */
export default function P3Regular({ sx, ...props }: TextProps) {
  return <Text {...props} sx={mergeTextSx(P3RegularStyle, sx)} />;
}
